import { useEffect, useRef } from 'react'
import { useImportZohoOrders } from '../../hooks/backend/scanPage'
import {
  AUTO_IMPORT_MINUTES,
  announceOrdersImported,
  type OrderImportResult,
} from '../../utils/orderImport'

// Imports Zoho orders every AUTO_IMPORT_MINUTES while the Hub is open and
// visible. The backend skips the run when any tab (or the Retool Workflow)
// imported within the window, so several open tabs don't pile up.
// Renders nothing.
export default function OrderImportAutoRun() {
  const importOrders = useImportZohoOrders()
  const triggerRef = useRef(importOrders.trigger)
  triggerRef.current = importOrders.trigger

  useEffect(() => {
    let busy = false
    let lastAttempt = 0
    const run = async () => {
      if (busy || document.visibilityState !== 'visible') return
      // A minute's grace so the backend's "imported recently" window lines up.
      if (Date.now() - lastAttempt < (AUTO_IMPORT_MINUTES - 1) * 60 * 1000) return
      busy = true
      lastAttempt = Date.now()
      try {
        const result = (await triggerRef.current({
          trigger: 'auto',
          onlyIfOlderThanMinutes: AUTO_IMPORT_MINUTES - 1,
        })) as OrderImportResult
        if (result?.ran && (result.run?.orders_fetched ?? 0) > 0) announceOrdersImported(result)
      } catch {
        // Errors are logged in order_import_runs and shown on the Orders page.
      } finally {
        busy = false
      }
    }
    void run()
    const timer = window.setInterval(() => void run(), 60 * 1000)
    const onVisible = () => void run()
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      window.clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [])

  return null
}
